/**
 * Mini sparkline chart for element history table cells
 */
import { LineChart, Line, YAxis, ResponsiveContainer } from 'recharts';

interface SparklineProps {
  data: Array<{ value: number | null }>;
  color?: string;
  width?: number;
  height?: number;
}

export function Sparkline({
  data,
  color = 'var(--mantine-color-blue-6)',
  width = 80,
  height = 24,
}: SparklineProps) {
  // Filter out null values for the chart
  const chartData = data
    .map((d, index) => ({ index, value: d.value }))
    .filter(d => d.value !== null);

  if (chartData.length < 2) {
    return <span style={{ color: 'var(--mantine-color-dimmed)' }}>—</span>;
  }

  return (
    <div style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <YAxis domain={['dataMin', 'dataMax']} hide />
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
